<template>
	<bsh-modal 
		titulo="Adicionar item"
		tamanho="modal-lg"
		:name="name">
		<template v-slot:default>
	        <item-form
				:dados="dados"
				:name="name"
				:errors="errors">
			</item-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="create">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	import Item from "./../../models/Item.js";
	export default {
		data(){
			return {
				dados: new Item(),
				name: 'create_item',
				errors: []
			}
		}, 
		methods: {
			create(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
				this.dados['pedido_id'] = this.$route.params.id;
	            axios.post(this.$url+'/api/adm/itens/store', (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.dados = new Item()
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
		},
	}
</script>